import styled from 'styled-components'
import { Table } from 'semantic-ui-react'

export const HeaderCell = styled(({ stickyHeader, zIndex, ...rest }) => (
  <Table.HeaderCell {...rest} />
))`
  &&& {
    color: ${props => props.theme.primaryFontColor};
    overflow: visible !important;
    transition: transform 0.3s;
    white-space: nowrap;
    position: ${({ stickyHeader, stickyHeaderNoOffset }) =>
      stickyHeader || stickyHeaderNoOffset ? 'sticky' : 'relative'} !important;
    top: ${({ stickyHeader, stickyHeaderNoOffset }) =>
      stickyHeader ? '55px' : stickyHeaderNoOffset ? '105px' : '0'};
    z-index: ${props => props.zIndex};
    background: #eff3f9;

    button .icon {
      top: 2px;
    }

    ${({ theme }) => theme.mediaQueries.mobile} {
      position: relative !important;
      top: 0;
    }
  }
`
